import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HealthCheckGlyph = /*#__PURE__*/createElement("g", {
  id: "health_check",
  style: {
    transform: 'translate(2px, 11px) scale(3.2)'
  }
}, /*#__PURE__*/createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/createElement("path", {
  d: "M21.9175 6.68885C21.9175 3.52838 19.3235 1 16.1656 1C14.5115 1 13.0453 1.66928 11.9927 2.78474C10.9401 1.70646 9.47389 1 7.81975 1C4.62426 1 2.06787 3.56556 2.06787 6.68885C2.06787 8.32485 2.74456 9.77495 3.87238 10.816L12.0303 18.8845L20.113 10.816C21.2032 9.77495 21.9175 8.32485 21.9175 6.68885Z",
  fill: "none",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M0 9.92372H7.59399L9.09774 4.97852L11.9549 13.3816L13.8346 8.21335L15.0376 11.5225L15.7519 9.92372H23.8722",
  fill: "none"
}), /*#__PURE__*/createElement("path", {
  d: "M0 9.92372H7.59399L9.09774 4.97852L11.9549 13.3816L13.8346 8.21335L15.0376 11.5225L15.7519 9.92372H23.8722",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/createElement("rect", {
  width: "25",
  height: "19",
  fill: "none"
}))));
const HealthCheck = createSvg({
  name: 'health_check',
  path: HealthCheckGlyph
});

export default HealthCheck;
export { HealthCheckGlyph };
